// extracted by mini-css-extract-plugin
export var dropdownButton = "_2j-0";
export var fullWidthDropdownButton = "_2j-1";
export var icon = "_2j-3";
export var iconPlaceholder = "_2j-2";
export var menuItemRow = "_2j-8";
export var separator = "_2j-c";
export var shortcutContainer = "_2j-7";
export var shortcutIconLg = "_2j-6";
export var shortcutIconMd = "_2j-5";
export var shortcutIconSm = "_2j-4";
export var submenuChevron = "_2j-b";
export var submenuDropdown = "_2j-9";
export var submenuTriggerRow = "_2j-a";